/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../Fixes';
import Builder from '../../../Builder';
import './common';
import '../../payments/network_numerics';
import '../../payments/common';
import '../common/common';
import '../common/metadata';
import '../../common/currency';
import '../../payments/push_money';
import '../../common/gateways';
import '../../binfo/api';
import '../common/scheme';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "esperanto": {
        "nested": {
          "api": {
            "nested": {
              "PushMoneyOptions": {
                "fields": {
                  "productSubcategory": {
                    "type": ".squareup.esperanto.api.ProductSubcategory",
                    "id": 2,
                    "rule": "optional",
                    "options": {
                      "default": "NONE"
                    }
                  },
                  "requestOrigin": {
                    "type": ".squareup.esperanto.api.PushMoneyOptions.RequestOrigin",
                    "id": 3,
                    "rule": "optional",
                    "options": {
                      "default": "CLIENT_ORIGINAL_REQUEST"
                    }
                  },
                  "processingCode": {
                    "type": ".squareup.esperanto.api.ProcessingCode",
                    "id": 4,
                    "rule": "optional",
                    "options": {
                      "default": "USE_DEFAULT"
                    }
                  },
                  "linkedTenderServerToken": {
                    "type": "string",
                    "id": 5,
                    "rule": "optional"
                  },
                  "accountUpdateRequested": {
                    "type": "bool",
                    "id": 18,
                    "rule": "optional"
                  },
                  "networkNumerics": {
                    "type": ".squareup.payments.networknumerics.NetworkNumerics",
                    "id": 19,
                    "rule": "optional"
                  }
                },
                "nested": {
                  "RequestOrigin": {
                    "values": {
                      "CLIENT_ORIGINAL_REQUEST": 1,
                      "CLIENT_RETRY_REQUEST": 2,
                      "FORWARDED_RETRY_REQUEST": 3
                    }
                  }
                }
              },
              "PushMoneyRequest": {
                "fields": {
                  "messageType": {
                    "type": ".squareup.payments.common.MessageType",
                    "id": 1,
                    "rule": "optional"
                  },
                  "clientPaymentKey": {
                    "type": ".squareup.esperanto.common.ClientPaymentKey",
                    "id": 2,
                    "rule": "optional"
                  },
                  "options": {
                    "type": ".squareup.esperanto.api.PushMoneyOptions",
                    "id": 3,
                    "rule": "optional"
                  },
                  "metadata": {
                    "type": ".squareup.esperanto.common.Metadata",
                    "id": 4,
                    "rule": "optional"
                  },
                  "merchant": {
                    "type": ".squareup.esperanto.api.Merchant",
                    "id": 5,
                    "rule": "optional"
                  },
                  "creatorToken": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "tender": {
                    "type": ".squareup.esperanto.api.Tender",
                    "id": 7,
                    "rule": "optional"
                  },
                  "amount": {
                    "type": ".squareup.common.Money",
                    "id": 8,
                    "rule": "optional"
                  },
                  "senderInfo": {
                    "type": ".squareup.payments.pushmoney.SenderInfo",
                    "id": 9,
                    "rule": "optional"
                  },
                  "targetGateway": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 10,
                    "rule": "optional"
                  },
                  "targetDebitNetwork": {
                    "type": ".squareup.binfo.api.DebitNetwork",
                    "id": 11,
                    "rule": "optional"
                  },
                  "targetAcquirer": {
                    "type": ".squareup.common.gateways.AcquirerName",
                    "id": 12,
                    "rule": "optional"
                  },
                  "recipientInfo": {
                    "type": ".squareup.payments.common.PaymentAccountInfo",
                    "id": 13,
                    "rule": "optional"
                  },
                  "referenceId": {
                    "type": "string",
                    "id": 14,
                    "rule": "optional"
                  }
                }
              },
              "PushMoneyResponse": {
                "fields": {
                  "paymentId": {
                    "type": "string",
                    "id": 1,
                    "rule": "optional"
                  },
                  "status": {
                    "type": ".squareup.esperanto.common.OperationStatus",
                    "id": 2,
                    "rule": "optional"
                  },
                  "error": {
                    "type": ".squareup.payments.pushmoney.PushMoneyError",
                    "id": 3,
                    "rule": "repeated"
                  },
                  "additionalFailedPaymentId": {
                    "type": "string",
                    "id": 12,
                    "rule": "repeated"
                  },
                  "gatewayTransactionId": {
                    "type": "string",
                    "id": 4,
                    "rule": "optional"
                  },
                  "retrievalReferenceNumber": {
                    "type": "string",
                    "id": 6,
                    "rule": "optional"
                  },
                  "accountUpdaterResult": {
                    "type": ".squareup.esperanto.common.AccountUpdaterResult",
                    "id": 5,
                    "rule": "optional"
                  },
                  "cardSchemeData": {
                    "type": ".squareup.esperanto.common.SchemeData",
                    "id": 7,
                    "rule": "optional"
                  },
                  "gatewayAccountNumber": {
                    "type": "string",
                    "id": 8,
                    "rule": "optional"
                  },
                  "cardNetwork": {
                    "type": ".squareup.payments.common.CardNetwork",
                    "id": 9,
                    "rule": "optional"
                  },
                  "selectedAcquirer": {
                    "type": ".squareup.payments.common.AcquiringEntity",
                    "id": 10,
                    "rule": "optional"
                  },
                  "gatewayName": {
                    "type": ".squareup.common.gateways.GatewayName",
                    "id": 11,
                    "rule": "optional"
                  },
                  "successfulRetryPossible": {
                    "type": "bool",
                    "id": 13,
                    "rule": "optional"
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PushMoneyOptions && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PushMoneyOptions?.nested?.RequestOrigin && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PushMoneyRequest && !$root.nested?.squareup?.nested?.esperanto?.nested?.api?.nested?.PushMoneyResponse) {
  $root.addJSON(jsonData);
}

/**
 * SOURCE PushMoneyOptions @ squareup/esperanto/api/push_money.proto at 19:1
 */
export const PushMoneyOptions = $root.lookupType('squareup.esperanto.api.PushMoneyOptions');
fixType(PushMoneyOptions);
Builder.createAndAttachToType(PushMoneyOptions);
/**
 * SOURCE RequestOrigin @ squareup/esperanto/api/push_money.proto at 25:3
 */
PushMoneyOptions.RequestOrigin = $root.lookupEnum('squareup.esperanto.api.PushMoneyOptions.RequestOrigin').values;
/**
 * Represents the request payload for the PushMoney.
 *
 * next id: 10
 *
 * SOURCE PushMoneyRequest @ squareup/esperanto/api/push_money.proto at 73:1
 */
export const PushMoneyRequest = $root.lookupType('squareup.esperanto.api.PushMoneyRequest');
fixType(PushMoneyRequest, {
  messageType: {
    required: true
  },
  clientPaymentKey: {
    required: true
  },
  merchant: {
    required: true
  },
  creatorToken: {
    required: true
  },
  tender: {
    required: true
  },
  amount: {
    required: true
  },
  senderInfo: {
    required: true
  }
});
Builder.createAndAttachToType(PushMoneyRequest);
/**
 * SOURCE PushMoneyResponse @ squareup/esperanto/api/push_money.proto at 110:1
 */
export const PushMoneyResponse = $root.lookupType('squareup.esperanto.api.PushMoneyResponse');
fixType(PushMoneyResponse);
Builder.createAndAttachToType(PushMoneyResponse);